<script setup>
import { computed } from 'vue'

const props = defineProps({ label: { type: String, default: '' }, size: { type: String, default: 'md' }, group: Boolean, title: { type: String, default: null } })
const initials = computed(() => props.label.split(/\s+/).filter(Boolean).slice(0, 2).map((w) => w[0]).join('').toUpperCase() || '?')
const hue = computed(() => [...props.label].reduce((h, c) => (h * 31 + c.charCodeAt(0)) % 360, 7))
const sizes = { xs: 'h-5 w-5 text-[9px]', sm: 'h-6 w-6 text-3xs', md: 'h-8 w-8 text-xs', lg: 'h-11 w-11 text-sm' }
</script>

<template>
  <span :class="['inline-flex shrink-0 items-center justify-center font-semibold text-white', group ? 'rounded-md' : 'rounded-full', sizes[size] || sizes.md]" :style="{ background: `hsl(${hue} 55% 45%)` }" :title="title ?? label">
    <i v-if="group" class="fa-solid fa-users text-[0.8em]" aria-hidden="true"></i>
    <template v-else>{{ initials }}</template>
  </span>
</template>
